import { db } from './firebase';

const POLLUTED_ID_REGEX = /^(newEvent|new-event.*|)$/;

export function isPollutedEventId(id: unknown): boolean {
  if (typeof id !== 'string') return true;
  return POLLUTED_ID_REGEX.test(id);
}

export function generateEventId(): string {
  return db.collection('_ids').doc().id;
}

export function normalizeEventId<T extends { id?: string | null }>(
  event: T,
  generateId: () => string = generateEventId,
): T & { id: string } {
  if (!isPollutedEventId(event.id)) {
    return event as T & { id: string };
  }
  return { ...event, id: generateId() };
}

export function cloneEventWithNewId<T extends { id?: string | null }>(
  event: T,
  generateId: () => string = generateEventId,
): T & { id: string } {
  return { ...event, id: generateId() };
}
